// extracted by mini-css-extract-plugin
export default {"season_icons":"Icons_season_icons__DUFMb","hide":"Icons_hide__qOih0","icon_nav_mobile":"Icons_icon_nav_mobile__uL3W5"};